/**
 * Just view/template component, no model/data logic!
 */
import React from "react"

// s4n
import { injectIntl, Link } from "gatsby-plugin-intl"
// import GeneralUtils from './../../../utils/common'
import kebabCase from "lodash.kebabcase"
// import "./../../assets/sass/templates/node/_blog.scss"
import ProductImage from './image'

// shop
import ProductPrice from './../Product/price'

import { cartAdd } from "../ext/actions"
import { connect } from 'react-redux'


const ComponentStateless = (props) => {
    const { intl, product, bootstrapColClass, dispatch } = props; // alias t === translate function
    const t = intl.formatMessage;

    const productId = product.drupal_internal__product_id;
    const languageId = intl.locale.toUpperCase();
    const variations = product && product.relationships && product.relationships.variations ? product.relationships.variations : null;
    const defaultVariation = variations ? variations[0] : null;
    const field_category = product && product.relationships && product.relationships.field_category ? product.relationships.field_category : null;

    const linkMap = {
        pl: `Sklep`,
        en: `Shop`,
    }
    const linkTranslation = kebabCase(linkMap[intl.locale]);

    return (
        <React.Fragment>
            <div className="card card-ecommerce">
                <div className="view overlay">

                    <Link to={product.path.alias} className="image">
                        <ProductImage product={product} />

                        {/* <span className="date">
                    {GeneralUtils.dateFormat(product.created, null, intl.locale)}
                    </span> */}
                    </Link>

                    <div className="mask rgba-white-slight waves-effect waves-light"></div>
                </div>
                <div className="card-body">
                    <h5 className="card-title">
                        <strong>
                            <Link to={product.path.alias} className="dark-grey-text">
                                {product.title}
                            </Link>
                        </strong>
                    </h5>

                    {/* <span className="badge badge-danger mb-2">bestseller</span> */}

                    {defaultVariation ?
                        <div className="card-footer">
                            <div className="row justify-content-between mb-0">
                                <span className="_float-left">
                                    <ProductPrice selectedVariation={defaultVariation} />
                                </span>
                                <span className="_float-right">
                                    <a
                                        href="#"
                                        onClick={() => dispatch(cartAdd(defaultVariation))}
                                        className="" 
                                        data-toggle="tooltip" 
                                        data-placement="top" 
                                        title={t({ id: "soft4net_shop_commerce_product_page_add_to_cart" })} 
                                        data-original-title={t({ id: "soft4net_shop_commerce_product_page_add_to_cart" })}
                                    >
                                        <i className="fas fa-shopping-cart ml-2"></i>
                                    </a>
                                </span>
                            </div>
                        </div>
                        : null
                    }

                    {field_category && !!field_category.length && <p className="categories">
                        {t({ id: "soft4net_lists_division_categories" })}:{` `}
                        {field_category.map((category, index) => {
                            const isLastItem = field_category.length === index + 1;

                            return (
                                <React.Fragment key={`${product.path.alias}-${category.name}`}>
                                    <Link to={`/${linkTranslation}/${kebabCase(category.name)}`} className={``}>{category.name}</Link>
                                    {isLastItem ? `` : `, `}
                                </React.Fragment>
                            )
                        })}
                    </p>}

                    {/* Reduce text to 10 words */}
                    {product.body && product.body.summary &&
                        <div className="description-short" dangerouslySetInnerHTML={{ __html: product.body.summary.split(' ').splice(0, 10).join(' ') + '...' }}></div>}

                    {/* {product.field_summary && <p dangerouslySetInnerHTML={{ __html: product.field_summary }}></p>} */}
                    {/* <Link to={ product.path.alias } className="btn btn-primary">
                    { t({ id: "soft4net_more" }) }
                </Link> */}

                </div>
            </div>
        </React.Fragment>
    )
}

const ComponentStatelessWrapped = injectIntl(ComponentStateless);
export default connect()(ComponentStatelessWrapped);
